import update from 'immutability-helper';
const INIT_STATE = null;


export default (state = INIT_STATE,action) => {
    switch(action.type){
      case 'SET_VOI_DATA':
        return action.payload
      default:
        return state
    }
  }
  